import { updateSessionPolicyRequestSchema, type UpdateSessionPolicyRequest } from '@stm/contracts';

/** Text the person typed; numbers are only produced when every field is a valid whole number in range. */
export interface SessionPolicyForm {
  staffIdleMinutes: string;
  familyIdleMinutes: string;
  absoluteDays: string;
}

function wholeNumber(text: string): number {
  return /^\d{1,5}$/.test(text.trim()) ? Number(text.trim()) : Number.NaN;
}

/** The request to save, or null while any field is empty, fractional or outside its allowed range. */
export function parseSessionPolicyForm(form: SessionPolicyForm): UpdateSessionPolicyRequest | null {
  const parsed = updateSessionPolicyRequestSchema.safeParse({
    staffIdleMinutes: wholeNumber(form.staffIdleMinutes),
    familyIdleMinutes: wholeNumber(form.familyIdleMinutes),
    absoluteDays: wholeNumber(form.absoluteDays),
  });
  return parsed.success ? parsed.data : null;
}
